module.exports = __webpack_public_path__ + "img/share2.a4d021a9.png";